<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div
    style="height: inherit"
    class="custom-chat chat-sidebar"
  >
    <div
      class="body-content-overlay"
      :class="{
        show: shallShowActiveChatContactSidebar || mqShallShowLeftSidebar,
      }"
      @click="
        mqShallShowLeftSidebar = shallShowActiveChatContactSidebar = false
      "
    />

    <!-- Main Area -->
    <section class="chat-app-window">
      <!-- Start Chat Logo -->
      <div
        v-if="!activeChannel.channel"
        class="start-chat-area"
      >
        <div class="mb-1 start-chat-icon">
          <feather-icon
            icon="MessageSquareIcon"
            size="56"
          />
        </div>
        <h4
          class="sidebar-toggle start-chat-text d-lg-none"
          @click="startConversation"
        >
          {{ $t("general.startConversation") }}
        </h4>
        <h4 class="sidebar-toggle start-chat-text d-none d-lg-block">
          {{ $t("general.selectMessageToStartYourConversation") }}
        </h4>
      </div>

      <!-- Chat Content -->
      <div
        v-else
        class="active-chat"
        @keydown="keyCloseConversation"
      >
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">
            <!-- Avatar & Name -->
            <div class="d-flex align-items-center">
              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon
                  icon="MenuIcon"
                  class="cursor-pointer"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
                />
              </div>

              <b-avatar
                size="36"
                class="mr-1 cursor-pointer badge-minimal"
                variant="light-primary"
                badge
                :badge-variant="
                  activeChannel.isOnline ? 'success' : 'secondary'
                "
                @click.native="shallShowActiveChatContactSidebar = true"
              />
              <h6 class="mb-0">
                {{ getChatName(activeChannel) }}
              </h6>
              <b-button
                v-if="activeChannel.serviceSystem && activeChannel.serviceSystem.status != 'resolved' && activeChannel.serviceSystem.status != 'cancel'"
                size="sm"
                variant="outline-primary"
                class="ml-1 mr-1"
                style="display: flex; align-items: center; gap: 4px;"
                @click="openServicePage"
              >
                {{ $t('breadcrumb.service') }}
                <feather-icon
                  icon="CastIcon"
                  size="16"
                />
              </b-button>
            </div>

            <!-- Contact Actions -->
            <div
              class="d-flex align-items-center"
              style="position: relative;"
            >
              <b-badge
                class="m-0 mr-50"
                :variant="getChannelStateVariant(activeChannel.state)"
              >
                <feather-icon icon="AlertCircleIcon" />
                {{ $t(`chat.${activeChannel.state}`) }}
              </b-badge>
              <!-- date filter -->
              <feather-icon
                icon="CalendarIcon"
                size="17"
                class="align-middle text-body"
                style="cursor: pointer; margin-right: 5px; margin-left: 5px"
                :class="{ 'text-primary': query.startDate || query.endDate }"
                @click="toggleDialog()"
              />
              <!-- Fixed dialog -->
              <div
                v-if="dialogVisible"
                class="fixed-date-picker-dialog"
                style="position: absolute"
              >
                <div>
                  <n-search-container
                    :show-header="false"
                    :fields="dateInputs"
                    :default-visible="true"
                    @search="search"
                    @reset="resetDate"
                  >
                    <n-search-input
                      v-model="query"
                      :fields="dateInputs"
                    />
                  </n-search-container>
                </div>
              </div>
              <div
                v-if="
                  !activeChannel.operatorAssigned ||
                    activeChannel.operatorAssigned == userData.id ||
                    userData.roleNames.includes('Super Admin')
                "
                class="dropdown"
              >
                <!--Header Section-->
                <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="17"
                      class="align-middle text-body"
                      @click="dialogVisible = false"
                    />
                  </template>

                  <!-- assign -->
                  <b-dropdown-item
                    v-if="
                      activeChannel.state == conversationStatus.open &&
                        !activeChannel.blockAt &&
                        !activeChannel.operatorAssigned &&
                        $can('manage', 'assign-chat')
                    "
                    :disabled="activeChannel.serviceSystem && activeChannel.serviceSystem.status != 'cancel' && activeChannel.serviceSystem.status != 'resolved'"
                    @click="assignOperator"
                  >
                    {{ $t("chat.assign") }}
                  </b-dropdown-item>

                  <!-- transfer Operator -->
                  <b-dropdown-item
                    v-if="
                      !isTransfer &&
                        activeChannel.state == conversationStatus.open &&
                        !activeChannel.blockAt &&
                        (activeChannel.operatorAssigned == userData.id ||
                          userData.roleNames.includes('Super Admin'))
                    "
                    :disabled="activeChannel.serviceSystem && activeChannel.serviceSystem.status != 'cancel' && activeChannel.serviceSystem.status != 'resolved'"
                    @click="assignOperator"
                  >
                    {{ $t("chat.transfer") }}
                  </b-dropdown-item>

                  <!-- transfer to other merchant -->
                  <b-dropdown-item
                    v-if="
                      !isTransfer &&
                        !activeChannel.transferredFrom &&
                        activeChannel.state == conversationStatus.open &&
                        !activeChannel.blockAt &&
                        (activeChannel.operatorAssigned == userData.id ||
                          userData.roleNames.includes('Super Admin'))
                    "
                    :disabled="activeChannel.serviceSystem && activeChannel.serviceSystem.status != 'cancel' && activeChannel.serviceSystem.status != 'resolved'"
                    @click="transferToOtherMerchant"
                  >
                    {{ $t("chat.transferToMerchant") }}
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="
                      !isTransfer &&
                        activeChannel.state == conversationStatus.open &&
                        !activeChannel.blockAt &&
                        $can('manage', 'close-conversation') &&
                        (activeChannel.operatorAssigned == userData.id ||
                          userData.roleNames.includes('Super Admin'))
                    "
                    :disabled="activeChannel.serviceSystem && activeChannel.serviceSystem.status != 'cancel' && activeChannel.serviceSystem.status != 'resolved'"
                    @click="confirmResolve(conversationStatus.close)"
                  >
                    {{ $t("chat.markAsResolve") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      activeChannel.state == conversationStatus.close &&
                        !activeChannel.blockAt &&
                        $can('manage', 'close-conversation')
                    "
                    :disabled="activeChannel.serviceSystem && activeChannel.serviceSystem.status != 'cancel' && activeChannel.serviceSystem.status != 'resolved'"
                    @click="confirmOpen(conversationStatus.open)"
                  >
                    {{ $t("button.openConversation") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      activeChannel.state == conversationStatus.open &&
                        !activeChannel.blockAt &&
                        $can('manage', 'block-customer')
                    "
                    :disabled="activeChannel.serviceSystem && activeChannel.serviceSystem.status != 'cancel' && activeChannel.serviceSystem.status != 'resolved'"
                    @click="confirmBan()"
                  >
                    {{ $t("chat.banThisCustomer") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      activeChannel.blockAt && $can('manage', 'block-customer')
                    "
                    :disabled="activeChannel.serviceSystem && activeChannel.serviceSystem.status != 'cancel' && activeChannel.serviceSystem.status != 'resolved'"
                    @click="confirmUnban()"
                  >
                    {{ $t("chat.unbanThisCustomer") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <feather-icon
                v-if="!mqShallShowRightSidebar"
                role="button"
                class="ml-1"
                size="16"
                icon="MenuIcon"
                @click="toggleRightSidebar"
              />
              <feather-icon
                v-else
                role="button"
                class="ml-1"
                size="16"
                icon="XIcon"
                @click="toggleRightSidebar"
              />
            </div>
          </header>

          <div v-if="isTranslate() && activeChannel.operatorAssigned == userData.id">
            <!-- live translate -->
            <div
              v-if="!activeChannel.isAutoTranslate && detectedLanguage"
              class="translateBox bg-primary"
            >
              <div
                class="dropdown chat-filter-dropdown ml-1"
                style="display: flex"
              >
                <div style="padding-top: 4px">
                  {{
                    $t("chat.detectedLanguage", {
                      visitorName: activeChannel.customer.name,
                    })
                  }}
                </div>
                &nbsp;
                <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="p-0"
                  class="detectLanguage-dropdown"
                >
                  <template #button-content>
                    <flag
                      :iso="getCountryCode(detectedLanguage.language)"
                      :squared="false"
                    />&nbsp;
                    <span class="text-white">{{ detectedLanguage.name }}</span>
                  </template>

                  <b-dropdown-form class="sticky-search">
                    <b-form-group>
                      <b-form-input
                        v-model="textSearch"
                        :placeholder="$t('general.search')"
                        @keydown.enter.prevent
                        @input="searchLocal"
                      />
                    </b-form-group>
                  </b-dropdown-form>

                  <b-dropdown-item
                    v-for="(local, index) in currentLocale"
                    v-if="localFilterSearch == ''"
                    :key="index"
                    @click="changeDetectedLanguage(local)"
                  >
                    <template v-if="local">
                      <flag
                        :style="{ zIndex: -1 }"
                        :iso="getCountryCode(local.language)"
                        :squared="false"
                      />
                      &nbsp;&nbsp;{{ local.name }}
                    </template>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-for="(local, index) in filteredLocal"
                    v-if="localFilterSearch != ''"
                    :key="index"
                    @click="changeDetectedLanguage(local)"
                  >
                    <template v-if="local">
                      <flag
                        :iso="getCountryCode(local.language)"
                        :squared="false"
                      />
                      &nbsp;&nbsp;{{ local.name }}
                    </template>
                  </b-dropdown-item>
                </b-dropdown>

                &nbsp;
                <b-button
                  class="cursor-pointer btn btn-success btn-sm"
                  :disabled="loading"
                  @click="
                    activeChannel.state == conversationStatus.open
                      ? isAutoTranslate(true)
                      : showAlert()
                  "
                >
                  <span v-if="!loading">{{
                    $t("chat.startLiveTranslate")
                  }}</span>
                  <span v-else>{{ $t("general.loading") }}</span>
                </b-button>
              </div>
            </div>
            <!-- /live translate -->

            <!-- translate processing(on) -->

            <div
              v-if="activeChannel.isAutoTranslate"
              class="bg-primary translateBox"
            >
              <div v-if="operatorLanguage">
                <span
                  v-b-tooltip.hover
                  :title="operatorLanguage.name"
                  style="cursor: pointer"
                >
                  <flag
                    :iso="getCountryCode(operatorLanguage.language)"
                    :squared="false"
                  />&nbsp;
                </span>
                &nbsp;
                <span
                  v-b-tooltip.hover
                  :title="detectedLanguage.name"
                  style="cursor: pointer"
                >
                  <flag
                    :iso="getCountryCode(detectedLanguage.language)"
                    :squared="false"
                  />&nbsp;
                </span>
                {{ $t("chat.liveTranslate") }}&nbsp;
                <b-button
                  class="cursor-pointer btn btn-danger btn-sm"
                  :disabled="loading"
                  @click="
                    activeChannel.state == conversationStatus.close
                      ? showAlert()
                      : isAutoTranslate(false)
                  "
                >
                  <span v-if="!loading">{{ $t("general.stop") }}</span>
                  <span v-else>{{ $t("general.loading") }}</span>
                </b-button>
              </div>
            </div>
            <!-- if(this.activeChannel.state == this.conversationStatus.close)return this.showAlert(); -->
            <!-- /translate on -->
          </div>
        </div>

        <!-- User Chat Area -->
        <div :class="messageBodyClass">
          <div
            v-if="!connectionStatus"
            class="connection-status no-internet"
          >
            <small>{{ $t("chat.noInternet") }}</small>
          </div>
          <div
            ref="refChatLogPS"
            class="user-chats scroll-area overflow-y"
            :class="{
              'pt-2': !connectionStatus,
            }"
            @click="onBodyClick"
            @scroll="handleScrollMessage"
          >
            <div class="infinite-wrapper">
              <infinite-loading
                v-show="messages.length"
                ref="infiniteLoading_prev"
                direction="top"
                :identifier="activeChannel.channel"
                @infinite="listMessage_prev"
              >
                <div slot="spinner">
                  <b-spinner label="Spinning" />
                </div>
                <div slot="no-more" />
                <div slot="no-results" />
              </infinite-loading>
            </div>
            <chat-message
              :key="chatBoxKey"
              :active-channel="activeChannel"
              :messages="messages"
              :read-message="activeChannel.readMessage"
              :is-typing="isTyping"
              @retry="retrySendMessage"
              @translate="manualTranslate"
            />
            <div class="infinite-wrapper">
              <infinite-loading
                v-show="messages.length"
                ref="infiniteLoading_next"
                direction="bottom"
                :identifier="activeChannel.channel"
                @infinite="listMessage_next"
              >
                <div slot="spinner">
                  <b-spinner label="Spinning" />
                </div>
                <div slot="no-more" />
                <div slot="no-results" />
              </infinite-loading>
            </div>
          </div>
          <div
            v-if="!hidePullDown && messages.length && !isSendingMsg"
            class="action-btn pull-down-btn btn-primary rounded-circle"
            :style="{
              bottom: pullDownStyle
            }"
            @click="fetchLatest"
          >
            <feather-icon
              icon="ArrowDownCircleIcon"
              size="40"
            />
          </div>
        </div>

        <!-- Message Input -->
        <chat-input
          v-if="
            !isTransfer &&
              activeChannel.state == conversationStatus.open &&
              (!activeChannel.operatorAssigned ||
                activeChannel.operatorAssigned == userData.id) &&
              !activeChannel.blockAt &&
              $can('manage', 'reply-customer')
          "
          ref="chatInput"
          :active-channel="activeChannel"
          :toggle-right-sidebar="toggleRightSidebar"
          @send-text="sendTextMessage"
          @send-attachment="sendAttachmentMessage"
          @auto-assign="autoAssignToOperator"
          @resize-chat-box="onResizeChatBox()"
        />
        <div
          v-else-if="
            activeChannel.state != 2 ||
              activeChannel.operatorAssigned == userData.id ||
              userData.roleNames.includes('Super Admin')
          "
          class="chat-footer px-4"
        >
          <div class="chat-app-form justify-content-center border-0">
            <p
              v-if="
                (activeChannel.state != conversationStatus.close &&
                  activeChannel.operatorAssigned &&
                  activeChannel.operatorAssigned != userData.id &&
                  userData.roleNames.includes('Super Admin')) ||
                  (activeChannel.operatorAssigned &&
                    activeChannel.operatorAssigned != userData.id &&
                    !userData.roleNames.includes('Super Admin'))
              "
              class="m-0 text-center"
            >
              <span v-if="activeChannel.isBot">
                <span v-if="activeChannel.botType == botType.ADVANCED">
                  {{$t('chat.alreadyAssignToAiAssistant')}}
                </span>
                <span v-else>
                 {{$t('chat.alreadyAssignToChatBot')}}
                </span>
              </span>
              <span v-else>
                {{
                  $t('chat.alreadyAssignTo', {
                    operator: activeChannel.merchantUserName
                  })
                }}
              </span>
              <b-button
                v-if="activeChannel.isBot"
                variant="primary"
                @click="enterChat"
                size="sm"
                style="margin-left: 1rem;"
              >
                {{ $t('field.chat') }}
              </b-button>
            </p>
            <p
              v-else-if="
                (activeChannel.state != conversationStatus.close &&
                  activeChannel.operatorAssigned &&
                  isTransfer &&
                  userData.roleNames.includes('Super Admin')) ||
                  (activeChannel.operatorAssigned &&
                    isTransfer &&
                    !userData.roleNames.includes('Super Admin'))
              "
              class="m-0 text-center"
            >
              {{
                $t("chat.alreadyAssignToOtherMerChant", {
                  toName: trasferredData.toName,
                })
              }}
            </p>

            <b-button
              v-if="
                !activeChannel.blockAt &&
                  activeChannel.state == conversationStatus.close &&
                  (!activeChannel.operatorAssigned ||
                    activeChannel.operatorAssigned == userData.id ||
                    userData.roleNames.includes('Super Admin')) &&
                  $can('manage', 'close-conversation')
              "
              variant="primary"
              block
              @click="confirmOpen(conversationStatus.open)"
            >
              {{ $t("general.startConversation") }}
            </b-button>
            <b-button
              v-if="
                activeChannel.blockAt &&
                  (activeChannel.operatorAssigned ||
                    activeChannel.operatorAssigned == userData.id) &&
                  $can('manage', 'block-customer')
              "
              variant="primary"
              block
              @click="confirmUnban()"
            >
              {{ $t("chat.unbanThisCustomer") }}
            </b-button>
          </div>
        </div>
      </div>
    </section>
    <!--{{ userData }}-->
    <!-- Active Chat Contact Details Sidebar -->
    <chat-active-chat-content-details-sidedbar
      :shall-show-active-chat-contact-sidebar.sync="
        shallShowActiveChatContactSidebar
      "
      :contact="activeChannel || {}"
    />

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <chat-left-sidebar
        :identifier="identifier"
        :channels="channels"
        :active-channel="activeChannel"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        :connection-status="connectionStatus"
        @filter="filter"
        @open-chat="openChannel"
        @load-channel="listChannel"
        @closeChannel="closeChannel"
      />
    </portal>
    <portal to="content-renderer-sidebar-right">
      <chat-right-sidebar
        :mq-shall-show-right-sidebar.sync="mqShallShowRightSidebar"
        :connection-status="connectionStatus"
        :send-text-message="changePreTextMessage"
        :active-channel="activeChannel"
      />
    </portal>
    <assign-operator-modal
      ref="assignOperatorModal"
      :active-channel="activeChannel"
      @reloadList="reloadList()"
    />
    <assign-merchant-modal
      ref="assignMerchantModal"
      :active-channel="activeChannel"
      @reloadList="reloadList()"
    />
    <load-profile />
  </div>
</template>

<script>
import store from '@/store'
import { ref } from '@vue/composition-api'
import {
  BAvatar,
  BDropdown,
  BDropdownItem,
  BForm,
  BInputGroup,
  BFormInput,
  BButton,
  BBadge,
  BSpinner,
  BImg,
  BDropdownDivider,
  BDropdownForm,
  BFormGroup,
  BInputGroupPrepend,
} from 'bootstrap-vue'

import { $themeBreakpoints } from '@themeConfig'
import { useResponsiveAppSidebarVisibility } from '@core/comp-functions/ui/app'
import ChatRightSidebar from '@/components/global-components/GChatRightSidebar.vue'
import Repository from '@/repositories/RepositoryFactory'
import conversationStatus from '@/data/conversationStatus'
import messageType from '@/data/messageType'
import botType from '@/data/botType'
import messageStatus from '@/data/messageStatus'
import languageEn from '@/data/languages/en'
import languageKm from '@/data/languages/km'
import languageZh from '@/data/languages/zh-cn'
import languageVi from '@/data/languages/vi'
import { getCountryByLanguageCode } from '@/libs/helper'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import InfiniteLoading from 'vue-infinite-loading'
import { connectSocket } from '@/libs/socket'
import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'
import { e2eDecrypt } from '@/libs/crypto-js'
import VueSweetalert2 from 'vue-sweetalert2'
import localeCountries from '@/data/localeCountries'
import useJwt from '@/auth/jwt/useJwt'
import NSearchContainer from '@/components/NSearchContainer'
import NSearchInput from '@/components/NSearchInput'
import AssignOperatorModal from './AssignOperatorModal.vue'
import AssignMerchantModal from './AssignMerchantModal.vue'
import ChatInput from './ChatInput.vue'
import ChatMessage from './ChatMessage.vue'
import ChatActiveChatContentDetailsSidedbar from './ChatActiveChatContentDetailsSidedbar.vue'
import ChatLeftSidebar from './ChatLeftSidebar.vue'
import TicketHistory from '../ticket/ticketRightSidebar/ticketHistory.vue'
import DateInputs from './searchDate.js'

const ChatChannelRepository = Repository.get('chatChannel')
const ChatMessageRepository = Repository.get('chatMessage')
const TranslateRepository = Repository.get('translateRepository')
const ChatAssignmentRepository = Repository.get('chatAssignmentRepository')
const PartnersShipRepository = Repository.get('partnersShip')

export default {
  components: {
    // BSV
    BAvatar,
    BDropdown,
    BDropdownItem,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,
    BBadge,
    BSpinner,
    BImg,
    BDropdownDivider,
    BDropdownForm,
    BFormGroup,
    BInputGroupPrepend,

    // 3rd Party
    InfiniteLoading,
    VueSweetalert2,

    // SFC
    ChatLeftSidebar,
    ChatRightSidebar,
    ChatActiveChatContentDetailsSidedbar,
    ChatMessage,
    ChatInput,
    AssignOperatorModal,
    AssignMerchantModal,
    NSearchContainer,
    NSearchInput,
  },
  data() {
    return {
      botType,
      channelFilter: {
        state: null,
        search: null,
        operator: null,
        isAuto: null,
        isUnread: null,
        isBlock: null,
        searchType: 'm',
        startDate: null,
        endDate: null,
      },
      localFilterSearch: '',
      identifier: 1,
      activeChannel: {},
      channels: [],
      channel: '',
      messages: [],
      message: '',
      channelPerPage: 15,
      channelPage: 1,
      messageLimit: 15,
      socket: null,
      isShowEmojiPicker: false,
      shallShowActiveChatContactSidebar: false,
      connectionStatus: true,
      isTyping: false,
      randomKey: null,
      isAutoAssignOperator: false,

      lastSeenMessageId: null,
      lastSeenMessageAt: null,

      conversationStatus,
      messageType,
      messageStatus,
      isModalOpen: false,
      show: false,
      isTranslationOn: null,
      chatBoxKey: 0,
      textSearch: '',
      loading: false,
      hidePullDown: true,
      debounce: this.createDebounce(),
      dialogVisible: false,
      query: {
        startDate: '',
        endDate: '',
      },
      isDateTimeFilter: false,
      filterOffset: 0,
      footerHeight: localStorage.getItem('chatFooterHeight') ? parseInt(localStorage.getItem('chatFooterHeight')) : 65,
      isSendingMsg: false,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
    locale() {
      return this.$i18n.locale.split('-')[0]
    },
    isTransfer() {
      if (this.activeChannel.transferred) {
        const transferring = this.activeChannel.transferred.find(
          e => !e.endedAt,
        )
        if (transferring) {
          return true
        }
      }
      return false
    },
    trasferredData() {
      if (this.activeChannel.transferred) {
        return this.activeChannel.transferred.find(e => !e.endedAt)
      }
      return {}
    },
    profilePicture() {
      if (this.$store.state.profile.profilePicture) {
        return this.$store.state.profile.profilePicture
      }

      return this.userData.profilePicture
    },
    detectedLanguage() {
      const data = this.getCountryByLanguageCode(
        this.currentLocale,
        this.activeChannel.detectedLanguage || this.$i18n.locale,
      )
      if (data) {
        return data
      }
      return null
    },
    operatorLanguage() {
      return getCountryByLanguageCode(
        this.currentLocale,
        this.activeChannel.operatorLanguage,
      )
    },
    currentLocale() {
      if (this.$i18n.locale === 'km') {
        return this.languageKm
      } if (this.$i18n.locale === 'en') {
        return this.languageEn
      } if (this.$i18n.locale === 'vi') {
        return this.languageVi
      }

      return this.languageZh
    },
    filteredLocal() {
      let local = []
      if (this.$i18n.locale === 'km') {
        local = this.languageKm
      } else if (this.$i18n.locale === 'en') {
        local = this.languageEn
      } else if (this.$i18n.locale === 'vi') {
        local = this.languageVi
      } else {
        local = this.languageZh
      }
      if (this.localFilterSearch.length > 0) {
        local = local.filter(value => {
          const name = value?.name?.toLowerCase()
          return name.startsWith(this.localFilterSearch.toLowerCase())
        })
      }
      return local
    },
    isSearchingMessage() {
      return (
        this.channelFilter.searchType == 'm'
        && this.channelFilter.search?.trim()
      )
    },
    messageBodyClass() {
      if (!this.isTransfer
            && this.activeChannel.state == this.conversationStatus.open
            && (!this.activeChannel.operatorAssigned
              || this.activeChannel.operatorAssigned == this.userData.id)
            && !this.activeChannel.blockAt) {
        this.resizeChatBody()
        return 'messages-body'
      }
      this.resetChatBodyResize()
      return 'message-body-no-chat-input'
    },
    isShowChatInput() {
      return !this.isTransfer
            && this.activeChannel.state == this.conversationStatus.open
            && (!this.activeChannel.operatorAssigned
              || this.activeChannel.operatorAssigned == this.userData.id)
            && !this.activeChannel.blockAt
    },
    pullDownStyle() {
      if (!this.isShowChatInput) {
        return '75px'
      }
      if (this.isTranslate() && this.footerHeight > 65) {
        return `${this.footerHeight + 30}px`
      }
      if (!this.isTranslate() && this.footerHeight >= 65) {
        return `${this.footerHeight + 25}px`
      }
      return '130px'
    },
  },
  watch: {
    connectionStatus(value, oldValue) {
      if (!oldValue && value) {
        this.reloadChannel()
        this.reloadMessage()
      }
    },

    lastSeenMessageId(value, oldValue) {
      if (value && value != oldValue) {
        this.submitReadMessage(
          this.activeChannel?.token,
          value,
          this.lastSeenMessageAt,
        )
      }
    },
    activeChannel(value, oldValue) {
      if (value && value != oldValue) {
        this.dialogVisible = false
        this.isDateTimeFilter = false
        this.filterOffset = 0
        if (!this.$route.query.channelId && !this.$route.query.from === 'topic-summary') {
          this.query = {
            startDate: '',
            endDate: '',
          }
        }
        this.$nextTick(() => {
          this.resizeChatBody()
        })
      }
    },
  },
  mounted() {
    window.addEventListener('chatSettings', event => {
      const data = JSON.parse(localStorage.getItem('chatSettings'))
      this.isTranslationOn = data?.isTranslationOn || true
    })

    window.addEventListener('chatSettings', event => {
      const data = JSON.parse(localStorage.getItem('chatSettings'))
      this.isTranslationOn = data?.isTranslationOn || true
    })

    this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
      bvEvent.vueTarget.$refs['close-button'].setAttribute('tabIndex', '-1')
      bvEvent.vueTarget.$refs['ok-button']?.focus()
    })
    window.addEventListener('keydown', this.keyCloseConversation)

    this.textSearch = this.localFilterSearch
    // if(this.$route.query.channelId && this.$route.query.from === 'topic-summary') {
    //   if(this.$route.query.msgStartDate) {
    //     this.query.startDate = this.$route.query.msgStartDate;
    //     this.$nextTick(() => {
    //       setTimeout(() => {
    //         this.search()
    //       }, 300)
    //     })
    //   }
    // }
  },
  created() {
    this.connectSocket()

    window.addEventListener('storage', evt => {
      if (evt.key == 'chatSettings' && evt.newValue == null) {
        if (localStorage.getItem('chatSettings') == null) {
          localStorage.setItem(
            'chatSettings',
            JSON.stringify(this.userData.chatSettings),
          )
        }
      }
    })
    if (localStorage.getItem('chatSettings') == null) {
      localStorage.setItem(
        'chatSettings',
        JSON.stringify(this.userData.chatSettings),
      )
    }

    this.randomKey = uuidv4()
    if (localStorage.getItem('tabKey') == null) {
      localStorage.setItem('tabKey', this.randomKey)
    }

    const self = this
    window.addEventListener('beforeunload', () => {
      localStorage.removeItem('tabKey')
    })
    window.addEventListener('storage', evt => {
      if (evt.key == 'tabKey' && evt.newValue == null) {
        if (localStorage.getItem('tabKey') == null) {
          localStorage.setItem('tabKey', self.randomKey)
        }
      }
    })
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyCloseConversation)
  },
  methods: {
    getChatName() {
      const name = this.activeChannel.nameTranslate || this.activeChannel.name 
      if (typeof name === 'object') {
        return name[this.locale] || name.en || name.zh || name.km || name.vi || name
      }
      return name
    },
    enterChat() {
      this.$bvModal
          .msgBoxConfirm(this.$t("alert.autoAssignIfReply"), {
            title: this.$t("alert.areYouSure"),
            size: "sm",
            buttonSize: "sm",
            okVariant: "primary",
            okTitle: <span ref="bvAgreeBtn">{this.$t("button.agree")}</span>,
            cancelTitle: this.$t("button.cancel"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              ChatChannelRepository.assign({ userId: this.userData.id, token: this.activeChannel.token })
                .then((response) => {
                  this.$emit("success");
                })
                .catch((error) => {
                  console.log('> enterChat error', error)
                })
            }
          });
    },

    updateQuerySting() {
      this.$router.replace({ query: this.query })
      this.$nextTick(() => {
        if (this.query.cache != 'no') {
          store.commit('app/UPDATE_CHAT_QUERY', { ...this.query })
        }
      })
    },
    getCountryCode(language) {
      return this.localeCountries.find(
        e => e.language.toLowerCase() === language.toLowerCase(),
      ).flag
    },

    isTranslate() {
      if (this.activeChannel.isAutoTranslate && this.activeChannel.operatorAssigned !== this.userData.id) {
        return true
      }
      const chatSetting = JSON.parse(localStorage.getItem('chatSettings')).isTranslationOn == 1
      const chatChannel = this.activeChannel.state != 1 // `1` = channel is opening
      const isTransferToMerchant = this.isTransfer
      const isAsignToOtherOperator = this.activeChannel.operatorAssigned != this.userData.id
      return chatChannel || isTransferToMerchant || isAsignToOtherOperator
        ? false
        : !!chatSetting
    },
    showAlert() {
      this.$swal.fire({
        text: this.$t('alert.pleaseOpenConversationFirst'),
        icon: 'warning',
        confirmButtonText: this.$t('button.close'),
      })
    },
    isAutoTranslate(isAutoTranslate) {
      this.loading = true
      const payload = {
        token: this.activeChannel.token,
        isAutoTranslate,
        detectedLanguage:
          this.activeChannel?.detectedLanguage || this.$i18n.locale,
      }
      ChatChannelRepository.isAutoTranslate(payload)
        .then(response => {
          this.loading = false
          const data = response?.data?.data
          if (data) {
            this.activeChannel = {
              ...this.activeChannel,
              isAutoTranslate: data.isAutoTranslate,
              detectedLanguage: data.detectedLanguage,
              operatorLanguage: data.operatorLanguage,
            }
          }
        })
        .catch(err => {
          this.loading = false
        })
    },
    searchLocal(text) {
      this.localFilterSearch = text
    },
    changeDetectedLanguage(selectedLang) {
      return (this.activeChannel = {
        ...this.activeChannel,
        detectedLanguage: selectedLang.language,
      })
    },
    changePreTextMessage(text) {
      this.$refs.chatInput.text = text
      this.$refs.chatInput.$refs.inputBox?.$el?.focus()
    },
    toggleRightSidebar() {
      this.mqShallShowRightSidebar = !this.mqShallShowRightSidebar
      this.preTextMessage = ''
    },
    connectSocket() {
      this.socket = connectSocket()

      this.socket.on('connect', () => {
        this.connectionStatus = true
        console.log('connect', this.socket)
        this.listenSocket()
      })

      this.socket.on('error', error => {
        console.log('error', error)
      })

      this.socket.on('connect_error', () => {
        console.log('connect_error', this.socket)
      })

      this.socket.on('connect_timeout', () => {
        console.log('connect_timeout', this.socket)
      })

      this.socket.on('disconnect', () => {
        this.connectionStatus = false
        console.log('disconnect', this.socket)
      })

      this.socket.on('ping', () => {
        console.log('ping', this.socket)
      })

      this.socket.on('reconnect', attempt => {
        console.log('reconnect', attempt)
      })

      this.socket.on('reconnect_attempt', attempt => {
        console.log('reconnect_attempt', attempt)
      })

      this.socket.on('reconnect_error', error => {
        console.log('reconnect_error', error)
      })

      this.socket.on('reconnect_failed', () => {
        console.log('reconnect_failed', this.socket)
      })

      this.socket.emit('join', {
        event: `${this.userData.merchantId}:channels`,
      })
    },
    leaveChannel(channel) {
      if (channel) {
        this.socket.emit('leave', {
          event: this.channel,
        })
      }
    },
    joinChannel(channel) {
      if (channel) {
        if (this.channel && this.channel != channel) {
          this.socket.emit('leave', {
            event: this.channel,
          })
        }

        this.channel = channel
        this.socket.emit('join', {
          event: channel,
        })
      }
    },
    listenSocket() {
      this.socket.on('chat:messages', data => {
        if (data?.data) {
          data.data = e2eDecrypt(data.data)
          if (!data.data) {
            return
          }
          data.data = JSON.parse(data.data)
          if (
            JSON.parse(localStorage.getItem('chatSettings')).isHideSystemChat
            && data.data.messageType === 5
          ) {
            return
          }
          if (this.activeChannel.channel != data.data.chatChannel) {
            return
          }

          if (
            this.activeChannel.transferred
            && this.activeChannel.transferred.findIndex(e => !e.endedAt) > -1
            && (!data.data.message.includes('action.transferring')
              || !data.data.message.includes('action.transferringEnded'))
          ) {
            return
          }

          const index = this.messages.findIndex(
            element => element.ref == data.data.ref,
          )
          if (data.data.participant.participantType == 'customer') {
            if (localStorage.getItem('tabKey') == this.randomKey) {
              // play notification
            }
          }
          if (index === -1) {
            this.messages.push({
              ...data.data,
              sentStatus: messageStatus.sent,
            })

            this.$nextTick(() => {
              this.scrollToBottom()
            })
          }
          this.lastSeenMessageAt = data.data.createdAt
          this.lastSeenMessageId = data.data.id
        }
        if (data.data.serviceSystem?.status == 'resolved') {
          const index = this.channels.findIndex(
            element => element.id == data.data.chatChannelId,
          )
          if (index != -1) {
            this.channels[index].serviceSystem = data.data.serviceSystem
          }
        }
      })
      this.socket.on('chat:actions', data => {
        if (data?.data) {
          data.data = e2eDecrypt(data.data)
          if (!data.data) {
            return
          }
          data.data = JSON.parse(data.data)
          if (!data.data) {
            return
          }

          if (data.type == 'channel') {
            if (this.isAutoAssignOperator && !data.data.merchantUserName) {
              return
            }
            const channel = { ...data.data }

            // if in state searching message
            const indexes = []
            if (this.isSearchingMessage) {
              this.channels.forEach((element, idx) => {
                if (
                  element.channel == data.data.channel
                  && element.latestMessage.isJumping
                  && data.data.state != element.channel.state
                ) {
                  indexes.push(idx)
                  this.channels[idx] = {
                    ...channel,
                    latestMessage: this.channels[idx].latestMessage,
                    badgeCount:
                      this.activeChannel.channel == element.channel
                        ? 0
                        : element.badgeCount,
                  }
                }
              })
            }

            if (this.activeChannel.channel == channel.channel) {
              this.activeChannel = {
                ...channel,
                badgeCount: this.activeChannel.badgeCount,
                readMessage: this.activeChannel.readMessage,
                latestMessage: this.isSearchingMessage
                  ? this.activeChannel.latestMessage
                  : channel?.latestMessage,
              }
            }

            const oneIndex = this.channels.findIndex(
              element => element.channel == data.data.channel,
            )

            indexes.push(oneIndex)

            const indexesTobeDelete = []

            // indexes to be procceed
            for (const index of indexes) {
              if (!this.synceChannel(data, index)) {
                indexesTobeDelete.push(index)
              }
            }

            if (indexesTobeDelete.length == indexes.length) {
              return
            }

            if (oneIndex > -1) {
              // adjust channel data
              // channel.badgeCount = this.activeChannel.channel == channel.channel
              //   ? 0
              //   : channel.badgeCount
              channel.readMessage = this.channels[oneIndex].readMessage
              // update position
              this.channels.splice(oneIndex, 1)
            }
            // update position / add new
            this.channels.unshift(channel)

            // update serviceSystem status
            if (data.data.latestMessage && data.data.latestMessage.messageType == 4 && data.data.latestMessage.message == 'action.serviceSystemResolved') {
              const index = this.channels.findIndex(
                element => element.id == data.data?.customer?.chatChannelId,
              )
              if (index != -1) {
                this.channels[index].serviceSystem = {
                  ...this.channels[index].serviceSystem,
                  status: 'resolved',
                }
              }
            }
          } else if (data.type == 'online') {
            const index = this.channels.findIndex(
              element => element.channel == data.data.channel,
            )
            if (index != -1) {
              this.channels[index].isOnline = data.data.isOnline
            }
            if (
              this.activeChannel.channel == data.data.channel
              && !this.isSearchingMessage
            ) {
              this.activeChannel = {
                ...data.data,
              }
            }
          } else if (data.type == 'seen') {
            if (data.data.participantType == 'merchant') {
              const index = this.channels.findIndex(
                element => element.channel == data.data.channel,
              )
              if (index != -1) {
                this.channels[index].badgeCount = data.data.badgeCount
              }
            }
          } else if (data.type == 'read') {
            if (data.data.participantType == 'merchant') {
              const index = this.channels.findIndex(
                element => element.channel == data.data.channel,
              )
              if (index != -1) {
                this.channels[index].readMessage = data.data.readMessage
              }
              if (this.activeChannel.channel == data.data.channel) {
                this.activeChannel.readMessage = data.data.readMessage
              }
            }
          } else if (data.type == 'typing') {
            if (
              this.activeChannel.channel == data.data.channel
              && data.data.participantType == 'customer'
            ) {
              this.isTyping = data.data.isTyping

              this.$nextTick(() => {
                const isTyping = true
                this.debounce(
                  () => this.scrollToBottom('instant', isTyping),
                  100,
                )
              })
            }
          } else if (data.type == 'deleteMessage') {
            const messageId = data?.data?.messageId
            const indexToRemove = this.messages.findIndex(
              message => message.id === messageId,
            )

            if (indexToRemove !== -1) {
              this.messages.splice(indexToRemove, 1)
            }
          }
          // else if (data.type == 'serviceResolve') {
          //   const index = this.channels.findIndex(
          //     element => element.id == data.data.chatChannelId,
          //   )
          //   console.log('broadcast data serviceResolve', index)
          //   if (index != -1) {
          //     this.channels[index].serviceSystem = data.data
          //   }
          // }
        }
      })
    },

    synceChannel(data) {
      const channel = data.data
      if (
        this.channelFilter.state
        && channel.state != this.channelFilter.state
      ) {
        return
      }
      if (
        this.channelFilter.search
        && !this.isSearchingMessage
        && channel.name.indexOf(this.channelFilter.search) == -1
      ) {
        return
      }
      if (
        this.isSearchingMessage
        && channel.latestMessage?.message.indexOf(this.channelFilter.search) == -1
      ) {
        return
      }
      if (
        this.channelFilter.operator
        && channel.operatorAssigned != this.channelFilter.operator
      ) {
        return
      }
      if (this.channelFilter.type == 'unassign' && channel.operatorAssigned) {
        return
      }

      return true
    },

    removeChannel(index) {
      if (index != -1) {
        this.channels.splice(index, 1)
        return true
      }
    },

    toUtc(dateStr, hours = 0) {
      const date = new Date(dateStr)
      if (hours > 0) {
        date.setHours(date.getHours() + hours)
      }
      const utcDate = new Date(
        Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds(),
        ),
      )
      return utcDate
    },

    addHours(dateStr, hours = 0) {
      const date = new Date(dateStr)
      if (hours > 0) {
        date.setHours(date.getHours() + hours)
      }
      return date
    },

    filter(query) {
      let state = null
      let isUnread = null
      let isBlock = null
      if (query.filter == 'unresolved') {
        state = 1
      } else if (query.filter == 'resolved') {
        state = 2
      } else if (query.filter == 'unread') {
        isUnread = 1
      } else if (query.filter == 'banned') {
        isBlock = 1
      }

      let type = ''
      let operator = null
      if (query.type == 'assignToMe') {
        operator = this.userData.id
      } else if (query.type == 'unassign') {
        type = 'unassign'
      } else if (query.operator) {
        operator = query.operator
      }

      const search = query.search ? query.search : null

      this.channelFilter.state = state
      this.channelFilter.search = search
      this.channelFilter.operator = operator
      this.channelFilter.type = type
      this.channelFilter.isUnread = isUnread
      this.channelFilter.isBlock = isBlock
      this.channelFilter.searchType = query.searchType
      this.channelFilter.startDate = query.startDate
      this.channelFilter.endDate = query.endDate
      // ? this.addHours(query.endDate, 24)
      // : null;

      this.channels = []
      this.channelPage = 1
      this.identifier++

      const channelId = query?.channel || query?.channelId
      if (channelId) {
        this.loadActiveChannel(channelId)
      }
    },
    loadActiveChannel(channelId) {
      ChatChannelRepository.detail({
        id: channelId,
      }).then(response => {
        const data = response?.data?.data
        if (data) {
          this.openChannel({ ...data })
        }
      })
    },
    async reloadChannel() {
      const date = this.channels[0] ? this.channels[0].updatedAt : ''
      if (date) {
        ChatChannelRepository.latest({
          order: 'updatedAt',
          sort: 'ASC',
          date,
          ...this.channelFilter,
        })
          .then(response => {
            const data = response?.data?.data?.list
            if (data) {
              data.forEach(element => {
                const index = this.channels.findIndex(
                  channel => channel.channel == element.channel,
                )
                if (index != -1) {
                  this.channels.splice(index, 1)
                }

                this.channels.unshift(element)

                if (this.activeChannel.channel == element.channel) {
                  this.activeChannel = {
                    ...element,
                  }
                }
              })
            }
          })
          .catch(error => {})
      } else {
        this.listChannel()
      }
    },
    async listChannel($state = null) {
      if (this.$route.query.from == 'topic-summary' && this.$route.query.channelId) {
        this.findChannel($state)
        return
      }
      if (!this.userData.isOffline) {
        // if operator offline=true, they're can see all new messagesChannels request
        const response = await ChatAssignmentRepository.show()
        const { data } = response.data
        this.isAutoAssignOperator = data?.auto || data?.autoRanking
        if (this.isAutoAssignOperator) {
          this.channelFilter.isAuto = true
        }
      }
      ChatChannelRepository.index({
        limit: this.channelPerPage,
        page: this.channelPage,
        order: 'updatedAt',
        ...this.channelFilter,
      })
        .then(response => {
          this.channelPage++

          const data = response?.data?.data
          if (data) {
            this.channels = [...this.channels, ...data.list]
            if (this.$route.query.channel) {
              const { channel } = this.$route.query
              const selectedExist = this.channels.find(
                val => val.id == channel,
              )

              if (!selectedExist && this.$route.query.filter != '') {
                this.activeChannel.channel = null // force no slected channel
              }
            }

            if ($state && data.list == 0) {
              $state.complete()
            }
          }
        })
        .catch()
        .then(() => {
          if ($state) {
            $state.loaded()
          }
        })
    },
    async findChannel($state = null) {
      if (!this.userData.isOffline) {
        // if operator offline=true, they're can see all new messagesChannels request
        const response = await ChatAssignmentRepository.show()
        const { data } = response.data
        this.isAutoAssignOperator = data?.auto || data?.autoRanking
        if (this.isAutoAssignOperator) {
          this.channelFilter.isAuto = true
        }
      }
      ChatChannelRepository.detail({
        id: this.$route.query.channelId,
      })
        .then(response => {
          const data = response?.data?.data
          if (data) {
            this.channels = [data]
            this.loadActiveChannel(this.$route.query.channelId)
            if ($state) {
              $state.complete()
            }
          }
        })
        .catch()
        .then(() => {
          if ($state) {
            $state.loaded()
          }
        })
    },
    reloadMessage() {
      const date = this.messages[this.messages.length - 1]
        ? this.messages[this.messages.length - 1].createdAt
        : ''
      ChatMessageRepository.latest({
        channel: this.activeChannel.channel,
        date,
      })
        .then(response => {
          const data = response?.data?.data
          if (data) {
            data.reverse()
            data.forEach(element => {
              this.messages.push(element)
            })
            this.$nextTick(() => {
              this.scrollToBottom()
            })
          }
        })
        .catch(error => {})
    },
    closeChannel() {
      this.activeChannel = {}
    },
    keyCloseConversation(event) {
      if (!this.isModalOpen) {
        if (
          this.activeChannel.state == this.conversationStatus.open
          && !this.activeChannel.blockAt
          && this.activeChannel.operatorAssigned == this.userData.id
        ) {
          if (event.ctrlKey && event.key === 'F2') {
            this.confirmResolve(this.conversationStatus.close)
          }
        }
      }
    },
    handleScrollMessage(e) {
      const el = e.target
      const distance = el.scrollHeight - (el.scrollTop + el.offsetHeight)
      if (distance <= 100) {
        this.hidePullDown = true
      } else if (this.hidePullDown) {
        this.hidePullDown = false
      }
    },
    fetchLatest() {
      this.scrollToBottom('smooth')
      // Proceed when infinite scroll not yet done.
      if (this.$refs.infiniteLoading_next.status != 2) {
        // Needed to complete next scroll. Prevent unstop fetching.
        this.$refs.infiniteLoading_next.stateChanger.complete()
        // Fetch latest messages.
        this.listMessage(null, null, true, true)
      }
    },
    listMessage_prev($state) {
      if (this.isDateTimeFilter) {
        this.$refs.infiniteLoading_prev.stateChanger.complete()
        return
      }
      this.listMessage($state, this.messages[0].createdAt)
    },
    listMessage_next($state) {
      console.log('list next')

      this.listMessage(
        $state,
        this.messages[this.messages.length - 1].createdAt,
        false,
      )
    },
    listMessage(
      $state = null,
      date = null,
      reverse = true,
      fetchLatest = false,
      channel = null,
    ) {
      // For topic summary referent
      if (this.$route.query.channelId && this.$route.query.from === 'topic-summary') {
        if (this.$route.query.msgStartDate) {
          this.query.startDate = this.$route.query.msgStartDate
          this.search()
          if ($state) {
            $state.complete()
          }
          return
        }
      }
      const query = {}

      if (date) {
        if (reverse) {
          query.lte = date
        } else {
          query.gte = date
        }
      }

      ChatMessageRepository.index({
        channel: channel || this.activeChannel.channel,
        limit: this.messageLimit,
        offset: 0, // always 0
        ...query,
      })
        .then(response => {
          const data = response?.data?.data

          if (data) {
            let isScrollBottom = true
            if (fetchLatest) {
              this.messages = []
              // Needed to reset prev scroll
              this.$refs.infiniteLoading_prev.stateChanger.reset()
            } else {
              isScrollBottom = this.messages.length == 0
            }
            this.$nextTick(() => {
              data.forEach(element => {
                if (element.chatChannelId == this.activeChannel.id) {
                  const isExist = this.messages.findIndex(
                    message => message.ref == element.ref,
                  )
                  if (isExist == -1) {
                    if (reverse) {
                      this.messages.unshift(element)
                    } else {
                      this.messages.push(element)
                    }
                  }
                }
              })
            })

            console.log('data', data.length, this.messageLimit)
            if ($state && data.length < this.messageLimit) {
              $state.complete()
            }

            if (isScrollBottom) {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.scrollToBottom()
                }, 100)
              })
            }
          }
        })
        .catch()
        .then(() => {
          if ($state) {
            $state.loaded()
          }
        })
    },
    filterMessageByDateTime(
      date,
    ) {
      if (date.startDate === '' && date.endDate === '') return
      const query = {}
      if (date.startDate) {
        query.gte = date.startDate
        if (!date.endDate) {
          const today = new Date()
          today.setHours(23, 59, 59, 999) // Set to end of day
          query.lte = today.toISOString()
        }
      }

      if (date.endDate) {
        const endDate = new Date(date.endDate).setSeconds(59)
        // date.endDate = new Date(date.endDate).setSeconds(59)
        query.lte = endDate
        if (!date.startDate) {
          this.listMessage(null, endDate, true, true)
          return
        }
      }

      ChatMessageRepository.index({
        channel: this.activeChannel.channel,
        limit: this.messageLimit,
        offset: this.isDateTimeFilter ? this.filterOffset : 0,
        ...query,
      })
        .then(response => {
          const data = response?.data?.data

          if (data) {
            if (!this.isDateTimeFilter) {
              this.messages = []
            }
            this.$nextTick(() => {
              data.forEach(element => {
                if (element.chatChannelId == this.activeChannel.id) {
                  const isExist = this.messages.findIndex(
                    message => message.ref == element.ref,
                  )
                  if (isExist == -1) {
                    this.messages.push(element)
                  }
                }
              })
            })
            if (data.length >= this.messageLimit) {
              console.log('data', data.length)
              this.filterMessageByDateTime(date)
            }
          }
        })
        .catch()
        .then(() => {
          this.isDateTimeFilter = true
          setTimeout(() => {
            this.scrollToTop()
            this.filterOffset += this.messageLimit
            this.$refs?.infiniteLoading_prev?.stateChanger.reset()
          }, 100)
        })
    },
    openChannel(channel) {
      this.isTyping = false
      this.activeChannel = channel
      if (this.activeChannel.operatorAssigned == this.userData.id) {
        this.activeChannel.badgeCount = 0
      }
      this.mqShallShowLeftSidebar = false
      this.messages = []
      this.joinChannel(this.activeChannel.channel)

      setTimeout(() => {
        this.$refs.infiniteLoading_prev.stateChanger.reset()
        this.$refs.infiniteLoading_next.stateChanger.reset()
      }, 150)

      switch (this.channelFilter.searchType) {
        case 'c':
          this.listMessage()
          break

        case 'm':
          const message = this.activeChannel.latestMessage
          const { channel } = this.activeChannel
          setTimeout(() => {
            console.log('list m')

            this.listMessage(
              this.$refs.infiniteLoading_prev.stateChanger,
              message.createdAt,
              true,
              false,
              channel,
            )

            const nextState = this.$refs.infiniteLoading_next.stateChanger

            nextState.complete()
            setTimeout(() => {
              console.log('list m next')
              this.listMessage(
                nextState,
                message.createdAt,
                false,
                false,
                channel,
              )
              setTimeout(() => {
                nextState.reset()
              }, 300)
            }, 500)
          }, 150)
          break

        default:
          break
      }
    },
    async sendTextMessage(message, translate) {
      this.isSendingMsg = true
      if (!message) {
        return
      }
      if (this.isDateTimeFilter || this.query.endDate) {
        this.resetDate()
      }

      this.$refs.chatInput.typing(false)

      const data = {
        ref: uuidv4(),
        createdAt: moment(),
        message,
        messageType: this.messageType.text,
        token: this.activeChannel.token,
      }

      await this.sendMessage(data, translate)
      this.$nextTick(() => {
        setTimeout(() => {
          this.isSendingMsg = false
        }, 100)
      })
    },
    sendAttachmentMessage(message) {
      if (!message.file && !(message.files && message.files.length)) {
        return
      }
      this.$refs.chatInput.typing(false)

      if (message.file) {
        const data = {
          ref: uuidv4(),
          createdAt: moment(),
          file: message.file,
          message: message.fileName,
          mediaUrl: message.fileUrl,
          messageType: this.messageType.attachment,
          token: this.activeChannel.token,
        }
        this.sendMessage(data)
        return
      }

      // multiple files
      const files = message.files
      const displayName = files.length > 1
        ? `${files[0].name} +${files.length - 1}`
        : files[0].name

      const data = {
        ref: uuidv4(),
        createdAt: moment(),
        files,
        message: displayName,
        messageType: this.messageType.attachment,
        token: this.activeChannel.token,
      }

      this.sendMessage(data)
    },
    retrySendMessage(index) {
      if (this.activeChannel.state != this.conversationStatus.open) {
        return
      }
      const message = this.messages[index]
      this.messages.splice(index, 1)
      this.sendMessage(message)
    },
    manualTranslate(index) {
      const message = this.messages[index]
      const target = this.$i18n.locale
      TranslateRepository.translate({ text: message.message, target }).then(
        response => {
          this.messages[index].translatedMessage = response?.data?.data?.translatedMessage
          this.messages[index].translatedLanguage = response?.data?.data?.translatedLanguage
          this.messages[index].detectedLanguage = response?.data?.data?.detectedLanguage

          this.chatBoxKey += 1
        },
      )
    },
    async uploadImage(message) {
      const formData = new FormData()
      formData.append('image', message.file)

      try {
        const response = await Client.post(
          `${Config.basePath}/upload/file`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: function (progressEvent) {
              const index = this.messages.findIndex(
                element => element.ref == message.ref,
              )
              if (index != -1) {
                this.messages[index].uploadPercentage = parseInt(
                  Math.round((progressEvent.loaded / progressEvent.total) * 100),
                )
              }
            }.bind(this),
          },
          {
            timeout: 10000000,
          },
        )

        const mediaId = response?.data?.data?.mediaId
        if (mediaId) {
          return mediaId
        }
      } catch (e) {
        // fall through to mark as fail below
      }
      const index = this.messages.findIndex(
        element => element.ref == message.ref,
      )
      if (index != -1) {
        this.messages[index].sentStatus = messageStatus.fail
      }
      return false
    },
    async sendMessage(message, translate) {
      const newMessage = {
        ...message,
        translatedMessage: translate?.translatedMessage,
        translatedLanguage: translate?.translatedLanguage,
        detectedLanguage: translate?.detectedLanguage,
        uploadPercentage: 0,
        participant: {
          participantType: 'merchant',
          id: this.userData.id,
        },
        profileUrl: this.profilePicture,
        sentStatus: this.messageStatus.sending,
      }

      this.messages.push(newMessage)

      this.$nextTick(() => {
        if (this.$refs.infiniteLoading_next.status == 2) {
          this.scrollToBottom('smooth')
        }
      })

      if (message.file) {
        const mediaId = await this.uploadImage(message)
        if (!mediaId) {
          // mark as failed so user can retry
          const idx = this.messages.findIndex(e => e.ref == message.ref)
          if (idx !== -1) this.messages[idx].sentStatus = this.messageStatus.fail
          return
        }

        message.mediaId = mediaId
      } else if (message.files && message.files.length) {
        let mediaIds = []
        try {
          mediaIds = await this.uploadFiles(message)
        } catch (e) {
          mediaIds = []
        }
        if (!mediaIds || !mediaIds.length) {
          const idx = this.messages.findIndex(e => e.ref == message.ref)
          if (idx !== -1) this.messages[idx].sentStatus = this.messageStatus.fail
          return
        }
        message.mediaIds = mediaIds
        // Keep local files array on the optimistic message to preserve names
        // This will be used to merge names back when server responds
        const index = this.messages.findIndex(e => e.ref == message.ref)
        if (index !== -1) {
          this.messages[index].files = message.files
        }
      }

      ChatMessageRepository.create({
        message: message.message,
        messageType: message.messageType,
        mediaId: message.mediaId,
        mediaIds: message.mediaIds,
        ref: message.ref,
        token: message.token || this.activeChannel.token,
      })
        .then(response => {
          const data = response?.data?.data
          if (data) {
            const index = this.messages.findIndex(
              element => element.ref == message.ref,
            )

            if (index != -1) {
              this.messages[index].id = data.id
              this.messages[index].createdAt = data.createdAt
              this.messages[index].sentStatus = this.messageStatus.sent
              this.messages[index].mediaUrl = data.mediaUrl
              // Support multiple media responses from API if available
              if (Array.isArray(data.mediaIds)) {
                // Preserve original filenames if server doesn't return them
                const localFiles = this.messages[index].files || []
                const mergedMedia = data.mediaIds.map((m, i) => {
                  const local = localFiles[i]
                  const localName = local?.fileName || local?.name
                  return {
                    ...m,
                    file_name: m.file_name || m.fileName || localName || m.file_name,
                    fileName: m.fileName || m.file_name || localName || m.fileName,
                    file_type: m.file_type || m.fileType,
                    fileType: m.fileType || m.file_type,
                  }
                })
                this.messages[index].mediaIds = mergedMedia
              }
              if (Array.isArray(data.mediaUrls)) {
                this.messages[index].mediaUrls = data.mediaUrls
              }
              if (Array.isArray(data.files)) {
                // some APIs may return a list of files with url/mimeType
                this.messages[index].mediaFiles = data.files
              }
            }

            // if it's jumping
            if (this.$refs.infiniteLoading_next.status != 2) {
              this.fetchLatest(newMessage)
            }
          }
        })
        .catch(error => {
          const index = this.messages.findIndex(
            element => element.ref == message.ref,
          )
          if (index != -1) {
            this.messages[index].sentStatus = this.messageStatus.fail
          }
        })
    },
    async uploadFiles(message) {
      const files = message.files || []
      if (!files.length) return []

      const uploadOne = async (file) => {
        const formData = new FormData()
        formData.append('image', file)
        try {
          const response = await Client.post(
            `${Config.basePath}/upload/file`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            },
            {
              timeout: 10000000,
            },
          )
          return response?.data?.data?.mediaId
        } catch (e) {
          return null
        }
      }

      const results = []
      for (const file of files) {
        const id = await uploadOne(file)
        if (id) results.push(id)
      }
      // if any file failed to upload, return empty to mark message as fail
      if (results.length !== files.length) return []
      return results
    },
    getChannelStateVariant(state) {
      if (state == this.conversationStatus.open) {
        return 'primary'
      }
      if (state == this.conversationStatus.close) {
        return 'success'
      }

      return 'danger'
    },
    assignOperator() {
      this.$refs.assignOperatorModal.show(
        this.activeChannel.token,
        !!this.activeChannel.operatorAssigned,
      )
    },
    transferToOtherMerchant() {
      const channelToken = this.activeChannel.token
      PartnersShipRepository.show()
        .then(response => {
          const { data } = response.data
          const partnerShip = [...data.list]
          if (partnerShip && partnerShip.length >= 1) {
            this.$refs.assignMerchantModal.show(
              channelToken,
              !!this.activeChannel.operatorAssigned,
            )
          } else {
            this.$swal.fire({
              text: this.$t('alert.pleaseAskAdminToBindAccount'),
              icon: 'warning',
              confirmButtonText: this.$t('button.close'),
            })
          }
        })
        .catch()
    },
    confirmResolve(state) {
      this.isModalOpen = true
      this.$bvModal
        .msgBoxConfirm(this.$t('alert.areYouSureToResolve'), {
          title: this.$t('alert.areYouSure'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: this.$t('chat.markAsResolve'),
          cancelTitle: this.$t('button.cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.updateStatus(state)
            if (this.isDateTimeFilter || this.query.endDate) {
              this.resetDate()
            }
          } else {
            this.isModalOpen = false
          }
        })
    },
    confirmOpen(state) {
      this.$bvModal
        .msgBoxConfirm(this.$t('alert.areYouSureToOpen'), {
          title: this.$t('alert.areYouSure'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: this.$t('general.startConversation'),
          cancelTitle: this.$t('button.cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            if (this.isDateTimeFilter || this.query.endDate) {
              this.resetDate()
            }
            this.fetchLatest()
            this.updateStatus(state)
          }
        })
    },
    confirmBan() {
      this.$bvModal
        .msgBoxConfirm(this.$t('alert.areYouSureToBan'), {
          title: this.$t('alert.areYouSure'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('chat.banThisCustomer'),
          cancelTitle: this.$t('button.cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.block()
            if (this.isDateTimeFilter || this.query.endDate) {
              this.resetDate()
            }
          }
        })
    },
    block() {
      const data = {
        token: this.activeChannel.token,
      }
      ChatChannelRepository.block(data)
        .then(response => {
          const data = response?.data?.data
          if (data) {
            this.activeChannel = {
              ...data,
            }
          }
        })
        .then(error => {})
    },
    confirmUnban() {
      this.$bvModal
        .msgBoxConfirm(this.$t('alert.areYouSureToUnban'), {
          title: this.$t('alert.areYouSure'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: this.$t('chat.unbanThisCustomer'),
          cancelTitle: this.$t('button.cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.unblock()
            if (this.isDateTimeFilter || this.query.endDate) {
              this.resetDate()
            }
          }
        })
    },
    unblock() {
      const data = {
        token: this.activeChannel.token,
      }
      ChatChannelRepository.unblock(data)
        .then(response => {
          const data = response?.data?.data
          if (data) {
            this.activeChannel = {
              ...data,
            }
          }
        })
        .then(error => {})
    },
    updateStatus(state) {
      // at stop translate at here
      const data = {
        state,
        token: this.activeChannel.token,
      }
      ChatChannelRepository.updateStatus(data)
        .then(response => {
          const data = response?.data?.data
          if (data && !this.isSearchingMessage) {
            this.activeChannel = {
              ...data,
            }
          }
        })
        .then(error => {
          this.isModalOpen = false
        })
    },
    submitReadMessage(token, messageId, readAt) {
      if (!token || !messageId || !readAt) {
        return
      }

      ChatMessageRepository.seen({
        token,
        messageId,
        readAt,
      })
        .then(response => {})
        .catch(err => {})
    },
    autoAssignToOperator() {
      if (this.activeChannel.operatorAssigned) {
        return
      }

      ChatChannelRepository.assign({
        token: this.activeChannel.token,
        userId: this.userData.id,
      })
        .then(response => {
          this.hide()
          this.$emit('success')
        })
        .catch(error => {
          if (error.response?.status == 422) {
            this.$refs.assignOperatorForm.setErrors(
              error.response?.data?.validate,
            )
          }
        })
        .then(() => {
          this.loading = false
        })
    },
    onBodyClick() {
      if (this.$refs.chatInput) {
        this.$refs.chatInput.closeEmoji()
      }
    },
    createDebounce() {
      let timeout = null
      return function (fnc, delayMs) {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          fnc()
        }, delayMs || 500)
      }
    },
    resizeChatBody() {
      this.hidePullDown = true
      const messageBodyEl = document.getElementsByClassName('messages-body')
      const messageNobodyEl = document.getElementsByClassName('message-body-no-chat-input')
      const chatFooterEl = document.getElementsByClassName('chat-footer')
      const userChat = document.getElementsByClassName('user-chats')
      if (messageNobodyEl.length > 0 && chatFooterEl.length > 0) {
        const chatFooterHeight = chatFooterEl[0].offsetHeight
        messageNobodyEl[0].style.height = `calc(100% - ${chatFooterHeight}px)`
      } else if (messageNobodyEl.length > 0 && chatFooterEl.length === 0) {
        messageNobodyEl[0].style.maxHeight = `${messageNobodyEl[0].scrollHeight}px`
        messageNobodyEl[0].style.height = `${messageNobodyEl[0].scrollHeight}px`
      }
    },
    resetChatBodyResize() {
      const messageBodyEl = document.getElementsByClassName('messages-body')
      const chatFooterEl = document.getElementsByClassName('chat-footer')
      if (messageBodyEl.length > 0 && chatFooterEl.length > 0) {
        messageBodyEl[0].style.height = 'calc(100% - 65px)'
      }
    },
    toggleDialog() {
      this.dialogVisible = !this.dialogVisible
    },
    resetDate() {
      this.$router.replace({
        query: {
          ...this.$router.query, channelId: null, msgStartDate: null, from: null,
        },
      })
      this.listMessage(null, null, true, true)
      this.query.startDate = ''
      this.query.endDate = ''
      this.isDateTimeFilter = false
      this.filterOffset = 0
      this.dialogVisible = false
    },
    search() {
      this.isDateTimeFilter = false
      this.filterOffset = 0
      this.filterMessageByDateTime(this.query)
      this.dialogVisible = false
    },
    onResizeChatBox() {
      this.hidePullDown = true
      const chatFooterEl = document.getElementsByClassName('chat-footer')
      if (chatFooterEl.length > 0) {
        const chatFooterHeight = chatFooterEl[0].offsetHeight
        this.footerHeight = chatFooterHeight
      }
    },
    openServicePage() {
      if (this.activeChannel.serviceSystem) {
        const url = this.$router.resolve({
          name: 'service-system',
          query: {
            status: null,
            from: 'chat',
            serviceSystemId: this.activeChannel.serviceSystem.id || this.activeChannel.serviceSystem._id,
          },
        })
        window.open(url.href, '_blank')
      }
    },
  },
  setup() {
    // Scroll to Bottom ChatLog
    const refChatLogPS = ref(null)
    const scrollToBottom = (behavior = 'instant', isTyping = false) => {
      const scrollEl = refChatLogPS.value?.$el || refChatLogPS.value
      const distant = scrollEl.scrollHeight - (scrollEl.scrollTop + scrollEl.offsetHeight)

      if (!isTyping) {
        scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior })
      } else if (distant <= 50 && isTyping) {
        scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior })
      }
    }
    const scrollToTop = (behavior = 'instant') => {
      const scrollEl = refChatLogPS.value?.$el || refChatLogPS.value
      if (scrollEl) {
        scrollEl?.scrollTo({ top: 0, behavior })
      }
    }

    // UI + SM Devices
    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar, mqShallShowRightSidebar } = useResponsiveAppSidebarVisibility()
    const startConversation = () => {
      if (store.state.app.windowWidth < $themeBreakpoints.lg) {
        mqShallShowLeftSidebar.value = true
      }
    }

    return {
      refChatLogPS,
      scrollToBottom,
      languageEn,
      languageKm,
      languageZh,
      languageVi,
      localeCountries,
      getCountryByLanguageCode,
      // UI + SM Devices
      startConversation,
      mqShallShowLeftSidebar,
      mqShallShowRightSidebar,
      dateInputs: DateInputs,
      scrollToTop,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";

.detectLanguage-dropdown .dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
}

.sticky-search {
  position: sticky;
  top: 0;
}

.flag {
  font-size: 18px;
}

.translateBox {
  color: #fff;
  padding: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.fixed-date-picker-dialog {
  position: fixed;
  height: 274px;
  top: 55px;
  left: -150px;
  width: 300px;
  z-index: 1000;
  background-color: #fff;
  border: 0px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2;
}
</style>
